import type { ErrorInfo } from "@octopusdeploy/design-system-components";
import type { MonitorErrorResource } from "@octopusdeploy/octopus-server-client";
export function createErrorInfoFromMonitorError(manifestError: MonitorErrorResource | undefined): ErrorInfo | undefined {
    if (!manifestError) {
        return;
    }
    return {
        message: manifestError.ErrorMessage,
        details: [
            {
                text: `Error code: ${manifestError.ErrorCode}`,
            },
        ],
    };
}
